import Marquee from "react-fast-marquee";

const EditorialMarquee = ({ items, dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`py-8 md:py-10 border-y overflow-hidden ${dark ? "bg-[#1A1A1A] border-white/10" : "bg-[#F7F5F2] border-[rgba(26,26,26,0.1)]"}`}
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className={`font-serif italic text-2xl md:text-4xl px-8 ${dark ? "text-[#F7F5F2]" : "text-[#1A1A1A]"}`}>
            {item}
          </span>
          <span className={`w-2 h-2 rotate-45 ${dark ? "bg-[#8C6A4F]" : "bg-[#8C6A4F]"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
